// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"bf1496b7","260":"4fcb7b47","450":"9314e562","511":"e57ae850","905":"8825e929"}[chunkId] + ".chunk.js";
};